import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailOutgoingRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-outgoing',
	path: '/secure/admin/OutgoingMailServers.jspa',
};
